import React, {useEffect, useState} from 'react';
import {observer} from 'mobx-react-lite';
import LoadingComponent from '../layout/components/widget/LoadingComponent';
import {ProtectedRouteProps} from '../../entity/props/core/protected-route-props';
import {useService} from '../../infrastructure/service/service';
import {useNavigate, useLocation} from 'react-router-dom';
import {UserRole} from '../../entity/enums/user-role';

const ProtectedRoute: React.FC<ProtectedRouteProps> = (props: ProtectedRouteProps): any => {
  const { userService, subscriptionService } = useService();
  const navigate = useNavigate();
  const location = useLocation();

  const [validSubscription, setValidSubscription] = useState<boolean | null>(null);

  useEffect(() => {
    const init = async () => {
      const user = await userService.getCurrentUser();

      if(!user?.organizationID) {
        navigate('/self-registration');
        return;
      }

      if (user.roles.includes(UserRole.GRANT_AI_USER)) {
        navigate('/grant-ai');
        return;
      }

      if (user.roles.includes(UserRole.GRANT_AI_ADMIN)) {
        const allowedPaths = ['/users', '/user-invitations'];
        if (!allowedPaths.includes(location.pathname)) {
          navigate('/grant-ai');
          return;
        } else {
          navigate(props.children);
          return;
        }
      }

      const validSubscription = await subscriptionService.validateSubscriptions(user?.organizationID ?? '');
      setValidSubscription(validSubscription);
    };

    init();
  }, []);

  if (validSubscription === null)
    return props.children;

  return (
    userService.isLoggedIn()
      ? validSubscription
          ? props.children
          : navigate(`/subscription${!userService.isAdminUser() ? '/expired' : ''}`)
      : <LoadingComponent />
  );
}

export default observer(ProtectedRoute);
